import React, { useMemo } from "react";
import Meta from "../components/Meta/Meta";

function NotFound() {
  const pageMetaProps = useMemo(() => {
    return {
      title: "Nile MSSN - 404",
      description:
        "Page not found. We couldn't find the page you were looking for. Please try searching for it or return to our homepage.",
      image: "",
      keywords: "nilemssn",
      author: "Nile MSSN",
      // twitterTitle: "",
      // twitterDescription: "",
      // twitterImage: "",
      // twitterCard: "",
    };
  }, []);

  return (
    <>
      <Meta {...pageMetaProps} />
      <div
        style={{
          color: "black",
          minHeight: "calc(100vh - 80px)",
          backgroundColor: "#9191911a",
        }}
      >
        <h1 style={{ paddingTop: "80px" }}>404 Not Found!</h1>
        <p style={{ textAlign: "center" }}>Subhanallah... Page not Found.</p>
      </div>
    </>
  );
}

export default NotFound;
